class JourneyCarousel extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.trackCardClicks();
  }

  trackCardClicks() {
    this.cards = this.querySelectorAll(".journey-carousel__block");
    const sectionHeading = this.querySelector(".journey-carousel__heading");

    this.cards.forEach((card) => {
      card.addEventListener("click", () => {
        const blockTextEl = card.querySelector(".journey-carousel__block-content-text");
        const imgEl = card.querySelector("img");
        const linkEl = card.querySelector("a");

        const clevertapData = {
          sectionTitle: sectionHeading?.innerText?.trim() || '',
          blockTitle: blockTextEl?.innerText?.trim() || '',
          Image_Link: imgEl?.getAttribute("src") || '',
          Landing_Page: linkEl?.getAttribute("href") || '',
        };

        if (clevertapData.blockTitle || clevertapData.Image_Link || clevertapData.Landing_Page) {
          dataLayer.push({
            event: "Banner_Clicked",
            sectionTitle: clevertapData.sectionTitle,
            blockTitle: clevertapData.blockTitle,
            Image_Link: clevertapData.Image_Link,
            Landing_Page: clevertapData.Landing_Page,
            clevertap: clevertapData
          });
        }
      });
    });
  }
}

customElements.define("journey-carousel", JourneyCarousel);